export default "__VITE_ASSET__DqTkFnNf__"